// Projects data with support for multiple languages.
// Data is organized by language code.

const projects = {
  listproject: [
    {
      id: 12,
      title: "Software Testing: Bank Administration System",
      img: require("@/assets/images/projects/issbankguarantee.jpg"),
      description_id: [
        "Merancang dan mengeksekusi lebih dari 100 test case fungsional dan edge case untuk seluruh modul dengan coverage test 95%, memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Terlibat dalam proses User Acceptance Testing. Mempresentasikan hasil pengujian, mencatat feedback user, dan melakukan retesting dari perbaikan feedback yang sudah diberikan",
        "Melakukan pengujian terhadap proses migrasi data dan memastikan 100% data migrasi aplikasi lama dapat diakses",
      ],
      description_en: [
        "Preparing and designing 100+ functional and edge test cases for all modules with 95% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the User Acceptance Testing and Production process, preventing potential failures during user presentations and production",
        "Participating in the User Acceptance Testing process. Presenting test results, recording user feedback, and performing retesting based on the provided feedback",
        "Testing the data migration process and ensuring 100% of the old application data can be accessed",
      ],
      tools: [],
      client: "PT. ISS Indonesia",
      date: "February 2026 - August 2026",
      tags: [
        "Test Case Development",
        "Manual Testing",
        "User Acceptance Testing",
      ],
      affiliate: "Techno Infinity",
      stars: "yes",
    },
    {
      id: 11,
      title: "Software Testing: K3 Training Management System",
      img: require("@/assets/images/projects/synergy.png"),
      description_id: [
        "Merancang dan mengeksekusi 50+ test case fungsional dan edge case untuk seluruh modul dengan coverage test 90%, memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses production, mencegah potensi failed di presentasi ke user maupun proses production",
      ],
      description_en: [
        "Preparing and designing 50+ functional and edge test cases for all modules with 90% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the User Acceptance Testing and Production process, preventing potential failures during user presentations and production",
      ],
      tools: [],
      client: "PT. Synergi Solusi Indonesia",
      date: "October 2025 - June 2026",
      tags: [
        "Test Case Development",
        "Manual Testing",
        "Automation Testing",
        "Security Scanning",
      ],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 10,
      title: "Software Testing: QHSSE Management Platform",
      img: require("@/assets/images/projects/pelni.png"),
      description_id: [
        "Menyusun dan Merancang 150+ test case fungsional dan edge case untuk semua modul dengan coverage test 90%. Memastikan flow bisnis dapat berjalan dengan baik",
        "Mengembangkan skrip end-to-end automation testing menggunakan Cypress untuk flow utama aplikasi, yang berhasil memangkas waktu regression testing dari pengujian 5 jam kerja menjadi 1 jam setiap siklus pengujian",
        "Menyusun dokumen hasil pengujian fungsional, pengujian keamanan (Security Testing), dan pengujian performa aplikasi",
        "Terlibat dalam proses User Acceptance Testing. Mempresentasikan hasil pengujian, mencatat feedback user, dan melakukan retesting dan training aplikasi dari perbaikan feedback yang sudah diberikan",
      ],
      description_en: [
        "Preparing and designing 150+ functional and edge test cases for all modules with 90% test coverage. Ensuring business flows run smoothly",
        "Developing end-to-end automation testing scripts using Cypress for the main application flows, successfully reducing regression testing time from 5 working hours to 1 hour per testing cycle",
        "Preparing documentation of functional testing, security testing, and application performance testing",
        "Participating in the User Acceptance Testing process. Presenting test results, recording user feedback, and performing retesting and application training based on the provided feedback",
      ],
      tools: ["Cypress", "k6 Grafana", "OWASP ZAP", "Postman"],
      client: "PT. PELNI (Persero)",
      date: "September 2024 - December 2025",
      tags: [
        "Test Case Development",
        "Manual Testing",
        "Automation Testing",
        "API Testing",
        "User Acceptance Testing",
      ],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "yes",
    },
    {
      id: 9,
      title: "Software Testing: SMKI Assessment Management System by Harmonie",
      img: require("@/assets/images/projects/harmonie.png"),
      description_id: [
        "Menyusun dan Merancang 40+ test case fungsional dan edge case untuk modul, memastikan flow pendaftaran dan seleksi magang hingga penilaian akhir mahasiswa dapat berjalan dengan baik",
        "Menyusun dokumen hasil pengujian fungsional, pengujian keamanan (Security Testing), dan pengujian performa aplikasi",
      ],
      description_en: [
        "Preparing and designing 40+ functional and edge test cases for the module, ensuring the registration and internship selection flows to the final student assessment run smoothly",
        "Preparing documentation of functional testing, security testing, and application performance testing",
      ],
      tools: ["k6 Grafana", "Postman"],
      client: "BPJS Kesehatan",
      date: "Maret 2025",
      link: "https://harmonie.id/",
      tags: ["Performance Testing", "Functional Testing"],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 8,
      title: "Software Testing: Enterprise Risk Management",
      img: require("@/assets/images/projects/safegard.jpg"),
      description_id: [
        "Menyusun dan Merancang 100+ test case fungsional dan edge case untuk semua modul dengan coverage test 90%. Memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses User Acceptance Testing dan Production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Mengembangkan skrip end-to-end automation testing menggunakan Cypress untuk flow utama aplikasi, yang berhasil memangkas waktu regression testing dari pengujian 4 jam kerja menjadi 1 jam setiap siklus pengujian",
        "Melakukan pengujian terhadap API untuk memvalidasi skema JSON dan melakukan code review terhadap beberapa fitur utama untuk mencari temuan awal aspek keamanan",
        "Menyusun dokumen hasil pengujian fungsional, pengujian keamanan (Security Testing), dan pengujian performa aplikasi",
      ],
      description_en: [
        "Preparing and designing 100+ functional and edge test cases for all modules with 90% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the User Acceptance Testing and Production process, preventing potential failures during user presentations and production",
        "Developing end-to-end automation testing scripts using Cypress for the main application flows, successfully reducing regression testing time from 4 working hours to 1 hour per testing cycle",
        "Testing APIs to validate JSON schemas and conducting code reviews for key features to identify early security issues",
        "Preparing documentation of functional testing, security testing, and application performance testing",
      ],
      tools: ["Cypress", "k6 Grafana", "SonarQube", "Postman"],
      client: "PT Permodalan Nasional Madani (PNM)",
      date: "April 2025 - August 2025",
      tags: [
        "Test Case Development",
        "Functional Testing",
        "Code Review",
        "Performance Testing",
        "API Testing",
        "Testing After Deployment",
      ],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "yes",
    },
    {
      id: 7,
      title: "Software Testing: Enterprise Risk Management",
      img: require("@/assets/images/projects/safegard.jpg"),
      description_id: [
        "Menyusun dan Merancang 100+ test case fungsional dan edge case untuk semua modul dengan coverage test 90%. Memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses User Acceptance Testing dan Production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Mengembangkan skrip end-to-end automation testing menggunakan Cypress untuk flow utama aplikasi, yang berhasil memangkas waktu regression testing dari pengujian 4 jam kerja menjadi 1 jam setiap siklus pengujian",
      ],
      description_en: [
        "Preparing and designing 100+ functional and edge test cases for all modules with 90% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the User Acceptance Testing and Production process, preventing potential failures during user presentations and production",
        "Developing end-to-end automation testing scripts using Cypress for the main application flows, successfully reducing regression testing time from 4 working hours to 1 hour per testing cycle",
      ],
      client: "Pancaran Group",
      date: "Mei 2024 - November 2024",
      tags: ["Test Case Development", "Functional Testing"],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 6,
      title: "Software Testing: Enterprise Risk Management",
      img: require("@/assets/images/projects/safegard.jpg"),
      description_id: [
        "Menyusun dan Merancang 100+ test case fungsional dan edge case untuk semua modul dengan coverage test 85%. Memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses User Acceptance Testing dan Production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Menyusun dokumen hasil pengujian fungsional, pengujian keamanan (Security Testing), dan pengujian performa aplikasi",
      ],
      description_en: [
        "Preparing and designing 100+ functional and edge test cases for all modules with 85% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the User Acceptance Testing and Production process, preventing potential failures during user presentations and production",
        "Preparing documentation of functional testing, security testing, and application performance testing",
      ],
      tools: ["Cypress"],
      client: "Direktorat Jenderal PPI Kementerian Komunikasi dan Digital",
      date: "Juni 2025",
      tags: ["Test Case Development", "Functional Testing"],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 5,
      title: "Software Testing: Enterprise Risk and Compliance Management App",
      img: require("@/assets/images/projects/safegard.jpg"),
      description_id: [
        "Menyusun dan Merancang 100+ test case fungsional dan edge case untuk semua modul dengan coverage test 90%. Memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Menyusun dokumen hasil assesmen fungsional, pengujian performa, dan keamanan aplikasi sebagai bagian dari proses maintenance aplikasi",
      ],
      description_en: [
        "Preparing and designing 100+ functional and edge test cases for all modules with 90% test coverage. Ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the production process, preventing potential failures during user presentations and production",
        "Preparing documentation of functional assessments, performance testing, and application security as part of the application maintenance process",
      ],
      tools: ["Cypress"],
      client: "PT Asuransi Jasa Indonesia",
      date: "January 2025 - Desember 2025",
      tags: ["Test Case Development", "Functional Testing"],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 4,
      title:
        "Software Testing: Workspace Human Resource Integration System (Mobile App)",
      img: require("@/assets/images/projects/workspace-mobile.png"),
      description_id: [
        "Merancang dan mengeksekusi 20+ test case fungsional dan edge case untuk seluruh modul dengan coverage test 95%, memastikan flow bisnis dapat berjalan dengan baik",
        "Mengembangkan skrip end-to-end automation testing menggunakan Katalon dan Appium untuk flow utama aplikasi, yang berhasil memangkas waktu regression testing dari pengujian 3 jam kerja menjadi 1 jam setiap siklus pengujian",
      ],
      description_en: [
        "Designing and executing 20+ functional and edge test cases for all modules with 95% test coverage, ensuring business flows run smoothly",
        "Developing end-to-end automation testing scripts using Katalon and Appium for the main application flow, successfully reducing regression testing time from 3 working hours to 1 hour per testing cycle",
      ],
      tools: ["Appium", "Katalon Studio"],
      client: "Proxsis Group",
      date: "November 2025 - Desember 2025",
      link: "https://work-space.id/",
      tags: ["Mobile App Testing", "Test Case Development"],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "no",
    },
    {
      id: 3,
      title: "Software Testing: Workspace Human Resource Integration System",
      img: require("@/assets/images/projects/workspace.jpg"),
      description_id: [
        "Merancang dan mengeksekusi 100+ test case fungsional dan edge case untuk seluruh modul dengan coverage test 95%, memastikan flow bisnis dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 10+ bug sebelum proses production, mencegah potensi failed di presentasi ke user maupun proses production",
        "Menyusun laporan hasil pengujian sebagai dokumentasi sebelum pelaksanaan User Acceptance Testing dan Production",
      ],
      description_en: [
        "Designing and executing 100+ functional and edge test cases for all modules with 95% test coverage, ensuring business flows run smoothly",
        "Identifying and reporting 10+ bugs before the production process, preventing potential failures during user presentations and production",
        "Preparing test result reports as documentation before User Acceptance Testing and Production",
      ],
      tools: ["Cypress"],
      client: "Proxsis Group",
      date: "Maret 2025 - Desember 2025",
      link: "https://work-space.id/",
      tags: [
        "Functional Testing",
        "Automation Testing",
        "Test Case Development",
      ],
      affiliate: "Techno Infinity (member of Proxsis Group)",
      stars: "yes",
    },
    {
      id: 2,
      title: "Software Testing: Talentern Internship Recruitment Platform",
      img: require("@/assets/images/projects/talentern.jpg"),
      description_id: [
        "Menyusun dan Merancang lebih dari 150 test case fungsional dan edge case untuk modul Mitra, Mahasiswa, LKM, dan Dosen & Kaprodi, memastikan flow pendaftaran dan seleksi magang hingga penilaian akhir mahasiswa dapat berjalan dengan baik",
        "Mengidentifikasi dan melaporkan 20+ bug berstatus major/critical  sebelum proses User Acceptance Testing, mencegah potensi failed di presentasi ke user maupun proses production",
        "Mengembangkan skrip end-to-end automation testing menggunakan Cypress untuk flow utama aplikasi, yang berhasil memangkas waktu regression testing dari pengujian 4 jam kerja menjadi 1 jam setiap siklus pengujian",
        "Melakukan pengujian terhadap fitur chatbot berbasis aturan (rule-based)",
      ],
      description_en: [
        "Preparing and designing more than 150 functional and edge test cases for the Partner, Student, LKM, and Lecturer & Head of Study Program modules, ensuring the internship registration and selection flow up to the final student assessment runs smoothly",
        "Identifying and reporting 20+ major/critical bugs before the User Acceptance Testing process, preventing potential failures during user presentations and production",
        "Developing end-to-end automation testing scripts using Cypress for the main application flow, successfully reducing regression testing time from 4 working hours to 1 hour per testing cycle",
        "Testing the rule-based chatbot feature",
      ],
      tools: ["Cypress", "Excel"],
      client: "LKM Fakultas Ilmu Terapan Telkom University",
      date: "June 2024 - Desember 2025",
      link: "https://talentern.telkomuniversity.ac.id/",
      tags: [
        "Functional Testing",
        "Chatbot Testing",
        "Automation Testing",
        "Test Case Development",
      ],
      affiliate: "Techno Infinity",
      stars: "yes",
    },
    {
      id: 1,
      title: "Mobile App Dev: E-Government Report App",
      img: require("@/assets/images/projects/report.jpg"),
      description_id: [
        "Aplikasi pelaporan untuk sistem e-government dengan fitur manajemen dokumen, tracking status laporan, dan dashboard analitik untuk administrator.",
      ],
      description_en: [
        "Reporting application for the e-government system with document management features, report status tracking, and an analytics dashboard for administrators.",
      ],
      tools: ["Flutter", "Codeigniter", "PHP"],
      client: "Pemerintah Kabupaten Jepara",
      date: "June 2022 - July 2022",
      tags: ["Mobile Application", "Technical Writing"],
      affiliate: "Dinas Komunikasi dan Informatika Kabupaten Jepara",
      stars: "no",
    },
  ],
};

export default projects;
